import { Controller } from "@hotwired/stimulus"

// The page guide: a panel that slides in from the right and explains the
// screen it is opened from. See shared/_help_sheet.html.erb.
//
// A native <dialog>, opened modally. That is the whole of the accessibility
// work DESIGN_SYSTEM §9 asks of a sheet — focus trapped inside, Esc closes,
// focus returned to the button afterwards, the page behind inert — and every
// line of it is the browser's. This controller only says when.
//
// A click on the dialog element itself is a click on the backdrop: the
// panel's own content fills the dialog, so anything inside it reports a
// descendant as the target.
export default class extends Controller {
  static targets = ["dialog"]

  open() {
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  backdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  // A Turbo visit replaces the page under an open dialog. The dialog is in the
  // top layer, so left alone it would stay drawn over the page that arrives.
  disconnect() {
    if (this.dialogTarget.open) this.close()
  }
}
